import { Svg } from 'components/svg'
import type { IconType } from 'models'

export const IconRss: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 512 512">
    <g fill="currentColor">
      <g transform="translate(89.53 70.262)">
        <path d="M0,0H357.477V357.477H0Z" fill="none" />
        <circle
          cx="32.471"
          cy="32.471"
          r="32.471"
          transform="translate(59.579 232.956)"
        />
        <path
          d="M8,8.89V51.042c104.711,0,189.612,84.9,189.612,189.612h42.152C239.689,112.633,135.947,8.89,8,8.89ZM8,93.12v42.152A105.348,105.348,0,0,1,113.307,240.579h42.152A147.509,147.509,0,0,0,8,93.12Z"
          transform="translate(51.579 57.318)"
        />
      </g>
    </g>
  </Svg>
)
